import Turbolinks from "turbolinks"

/**
 * Navigate and maintain scroll position
 */
export default class {
    scrollPosition = null
    onBeforeVisit
    onLoad

    /**
     * Get the current y position
     * @returns {number}
     */
    get currentScroll()
    {
        return window.scrollY
    }

    constructor()
    {
        this.onLoad = this.handleLoad.bind(this)
        this.setup()
    }

    /**
     * Listen for turbolinks load
     */
    setup()
    {
        document.addEventListener('turbolinks:load', this.onLoad)
    }

    /**
     * Store the scroll position and visit a URL
     * @param url
     */
    visit(url)
    {
        this.scrollPosition = this.currentScroll
        Turbolinks.visit(url);
    }

    /**
     * When a new page loads, set the new position.
     */
    handleLoad()
    {
        if (this.scrollPosition) {
            window.scrollTo(0, this.scrollPosition)
            this.scrollPosition = null
        }
    }

    /**
     * Stop listening to Turbolinks loads.
     */
    stopListening()
    {
        document.removeEventListener('turbolinks:load', this.onLoad)
    }

    /**
     * Do anything we need to do on page change.
     */
    tearDown()
    {
        this.stopListening()
    }
}
